export default __webpack_public_path__ + "static/christian-9430e085f2b9760656ef4333c1771c23.png";